import React, { useState, useEffect } from "react";
import { useFetch } from "../../../../components/common/FetchProvider";
import Loader from "components/Loader/Loader";
import InputField from "components/fields/InputField";
import ErrorModal from "../../reports/components/ErrorModal";
import {getDateRange} from "utils/utils"

const TransferModal = ({ showModal, setModalState, refreshData, organizationData, organizationId, accountId, availableAccounts, allAccounts, existingFormData, setExistingFormData, addPreviousMonthRecord}) => {
    const fetchWrapper = useFetch();
    const [errorMessages, setErrorMessages] = useState({});
    const [loading, setLoading] = useState(false);
    const [destinationDepartment, setDestinationDepartment] = useState("");
    const [destinationAccounts, setDestinationAccount] = useState([]);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [formData, setFormData] = React.useState({
        sourceDepartment: organizationId,
        sourceAccount: accountId,
    });

    const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");

    useEffect(() => {
        const { minDate, maxDate } = getDateRange(addPreviousMonthRecord);
        setMinDate(minDate);
        setMaxDate(maxDate);
    }, [addPreviousMonthRecord]);

    const [formErrorData, setFormErrorData] = useState({});

    const handleInputChange = (event) => {
        errorMessages.message = "";
        setFormErrorData({});
        const { id, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const setFormValues = (id, value) => {
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const setErrorForField = (field) => {
        setFormErrorData({ [field]: "error" });
    }

    const errors = {
        registrationDate: "Please enter Data de registro",
        confirmationDate: "Please enter Data de confirmação",
        sourceDepartment: "Please select Departamento de origem",
        sourceAccount: "Please select Conta de origem",
        originValue: "Please enter Origem do valor",
        destinationDepartment: "Please select Departamento de destino",
        destinationAccount: "Please select Conta de destino",
        destinationValue: "Please enter Valor alvo",
        description: "Please enter Descrição",
        apiError: "Something went wrong"
    };

    const validationRules = {
        registrationDate: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.registrationDate,
        },
        sourceDepartment: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.sourceDepartment,
        },
        sourceAccount: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.sourceAccount,
        },
        originValue: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.originValue,
        },
        destinationDepartment: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.destinationDepartment,
        },
        destinationAccount: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.destinationAccount,
        },
        destinationValue: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.destinationValue,
        },
        description: {
            validate: (value) => value && value.length >= 5,
            message: errors.description,
        }
    };

    useEffect(() => {
        setExistingData(existingFormData);
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showModal]);

    const handleOrganizationsChange = (event) => {
        errorMessages.message = "";
        setFormErrorData({});
        const selectedOrganizationId = event.target.value; // Get the selected value (id)
        setDestinationDepartment(selectedOrganizationId); // Update the state with the selected id
        setDestinationAccount([]);
        const filteredAccounts = allAccounts.filter(
            (account) => account.organizationId === Number(selectedOrganizationId)
        );
        setDestinationAccount(filteredAccounts);
        setFormValues('destinationDepartment', selectedOrganizationId);
    };

    const setExistingData = (data) => {
        if (data !== null && data !== undefined && data.id != null) {
            setFormData(data)
        }
    }

    const handleCancel = () => {
        setExistingFormData(null);
        setModalState(false);
    }

    const handleSubmit = async () => {
        for (let field in validationRules) {
            const { validate, message } = validationRules[field];
            if (!validate(formData[field])) {
                setErrorMessages({ name: field, message: message });
                setErrorForField(field);
                return;
            }
        }

        setLoading(true);

        try {
            const requestOptions = {
                method: existingFormData != null && existingFormData.id !== undefined ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(formData)
            };

            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/transfers`;
            const response = await fetchWrapper(apiUrl, requestOptions);
            setLoading(false);
            if (response.ok) {
                const responseData = await response.json();
                refreshData();
                setModalState(false);
                window.open(`../reports/transfer-report?id=${responseData.data.id}`)

            }
        } catch (error) {
            setLoading(false);
            if (error.body && error.body.responseInfo) {
                setErrorMessage(error.body.responseInfo.message);
                setShowErrorModal(true);
            } else {
                console.error("Error: Unable to handle ", error);
                setErrorMessage("Ocorreu um erro inesperado");
                setShowErrorModal(true);
            }
        }
    };

    const updateDescription = async () => {
        setLoading(true);
        try {
            const requestOptions = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify({
                    id: existingFormData.id,
                    description: formData.description,
                })
            };
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/transfers/description`;
            const response = await fetchWrapper(apiUrl, requestOptions);
            setLoading(false);
            if (response.ok) {
                const responseBody = await response.json();
                refreshData();
                setExistingFormData({id: responseBody.data.id});
                setModalState(false);
            }
        } catch (error) {
            setLoading(false);
            if (error.body && error.body.responseInfo) {
                setErrorMessage(error.body.responseInfo.message);
                setShowErrorModal(true);
            } else {
                console.error("Error: Unable to handle ", error);
                setErrorMessage("Ocorreu um erro inesperado");
                setShowErrorModal(true);
            }
        }
    }

    return (
      <>
        {showErrorModal && (
          <ErrorModal
            showErrorModal={showErrorModal}
            setShowErrorModal={setShowErrorModal}
            errorMessage={errorMessage}
          />
        )}
        {showModal && !showErrorModal ? (
          <>
            <Loader show={loading} />
            <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
              <div className="relative mx-auto my-10 w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                <div className="relative flex flex-col rounded-lg border-0 bg-white font-normal text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">
                  {/* Modal Header */}
                  <div className="border-slate-200 flex items-start justify-between rounded-t border-b border-solid p-5">
                    <h4 className="text-3xl font-semibold">
                      Cadastrar Transferencia
                    </h4>
                  </div>

                  {/* Modal Body */}
                  <div
                    className="space-y-4 p-5"
                    style={{ overflowY: "auto", maxHeight: "70vh" }}
                  >
                    <div className="min-h-[1.30rem] text-red-500">
                      {errorMessages.message}
                    </div>

                    {/* Row 1: Payment Date with Calendar Icon and Document Number */}
                    <div className="flex items-start space-x-4">
                      {/* Document Number Field */}
                      <div className="w-full">
                        <InputField
                          extra="text-navy-800"
                          variant="auth"
                          label="Data de registro"
                          id="registrationDate"
                          type="date"
                          state={
                            formErrorData.registrationDate === "error"
                              ? "error"
                              : ""
                          }
                          value={formData.registrationDate}
                          onChange={handleInputChange}
                          disabled={
                            existingFormData && existingFormData.disabledView
                          }
                          min={minDate}
                          max={maxDate}
                        />
                      </div>
                    </div>

                    <div className="flex items-start space-x-4">
                      {/* First Dropdown Field */}
                      <div className="w-1/3">
                        <label className="ml-1.5  text-sm font-medium dark:text-white">
                          Departamento de origem
                        </label>
                        <select
                          className={`mt-1 h-12 w-full cursor-not-allowed rounded-xl border bg-gray-100 p-3 text-sm text-gray-800 outline-none dark:!border-white/10 dark:text-white`}
                          id="sourceDepartment"
                          value={formData.sourceDepartment}
                          disabled
                        >
                          <option value="">
                            Selecione departamento de origem
                          </option>
                          {organizationData &&
                            organizationData.map((organization) => (
                              <option
                                key={organization.id}
                                value={organization.id}
                              >
                                {organization.name}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="w-1/3">
                        <label className="ml-1.5  text-sm font-medium dark:text-white">
                          Conta de origem
                        </label>
                        <select
                          className={`mt-1 h-12 w-full cursor-not-allowed rounded-xl border bg-gray-100 p-3 text-sm text-gray-800 outline-none dark:!border-white/10`}
                          id="sourceAccount"
                          value={formData.sourceAccount}
                          onChange={handleInputChange}
                          disabled
                        >
                          <option value="">Selecione conta de origem</option>
                          {availableAccounts &&
                            availableAccounts.map((accounts) => (
                              <option key={accounts.id} value={accounts.id}>
                                {accounts.accountNumber
                                  ? accounts.accountNumber
                                  : accounts.accountName}{" "}
                                - {accounts.accountCurrency}
                              </option>
                            ))}
                        </select>
                      </div>

                      {/* Text Field 1 */}
                      <div className="w-1/3">
                        <InputField
                          variant="auth"
                          label="Origem do valor"
                          placeholder="Origem do valor"
                          id="originValue"
                          type="number"
                          state={
                            formErrorData.originValue === "error" ? "error" : ""
                          }
                          value={formData.originValue}
                          onChange={handleInputChange}
                          disabled={
                            existingFormData && existingFormData.disabledView
                          }
                        />
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      {/* First Dropdown Field */}
                      <div className="w-1/3">
                        <label className="ml-1.5  text-sm font-medium dark:text-white">
                          Departamento de destino
                        </label>
                        <select
                          className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${
                            formErrorData.destinationDepartment === "error"
                              ? "border-red-500"
                              : ""
                          }`}
                          id="destinationDepartment"
                          value={formData.destinationDepartment}
                          onChange={handleOrganizationsChange}
                          disabled={
                            existingFormData && existingFormData.disabledView
                          }
                        >
                          <option value="">
                            Selecione departamento de destino
                          </option>
                          {organizationData &&
                            organizationData.map((organization) => (
                              <option
                                key={organization.id}
                                value={organization.id}
                              >
                                {organization.name}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="w-1/3">
                        <label className="ml-1.5  text-sm font-medium dark:text-white">
                          Conta de destino
                        </label>
                        <select
                          id="destinationAccount"
                          value={formData.destinationAccount}
                          onChange={handleInputChange}
                          disabled={
                            existingFormData && existingFormData.disabledView
                          }
                          className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${
                            formErrorData.destinationAccount === "error"
                              ? "border-red-500"
                              : ""
                          }`}
                        >
                          <option value="">Selecione conta de destino</option>

                          {destinationAccounts &&
                            destinationAccounts.map((accounts) => (
                              <option key={accounts.id} value={accounts.id}>
                                {accounts.accountNumber
                                  ? accounts.accountNumber
                                  : accounts.accountName}{" "}
                                - {accounts.accountCurrency}
                              </option>
                            ))}
                        </select>
                      </div>

                      {/* Text Field 1 */}
                      <div className="w-1/3">
                        <InputField
                          variant="auth"
                          label="Valor alvo"
                          placeholder="Valor alvo"
                          id="destinationValue"
                          type="number"
                          state={
                            formErrorData.destinationValue === "error"
                              ? "error"
                              : ""
                          }
                          value={formData.destinationValue}
                          onChange={handleInputChange}
                          disabled={
                            existingFormData && existingFormData.disabledView
                          }
                        />
                      </div>
                    </div>

                    <InputField
                      variant="auth"
                      extra="w-full mb-3"
                      label="Descrição"
                      placeholder="Descrição"
                      id="description"
                      type="text"
                      state={
                        formErrorData.description === "error" ? "error" : ""
                      }
                      value={formData.description}
                      onChange={handleInputChange}
                    />

                    <div className="w-1/3">
                      <label className="ml-1.5  text-sm font-medium dark:text-white">
                        É conversão de dinheiro
                      </label>
                      <select
                        className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10`}
                        id="cashConversion"
                        value={formData.cashConversion}
                        onChange={handleInputChange}
                        disabled={
                            existingFormData && existingFormData.disabledView
                        }
                      >
                        <option value="">não</option>
                        <option value="yes">Sim</option>
                      </select>
                    </div>
                  </div>

                  {/* Modal Footer */}
                  <div className="border-slate-200 flex items-center justify-end rounded-b border-t border-solid p-5">
                    <button
                      onClick={handleCancel}
                      className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                    >
                      Cancelar
                    </button>
                    {existingFormData && existingFormData.disabledView ? (
                      <button
                        onClick={updateDescription}
                        className={`linear dark:active:bg-brand-200" ml-auto mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white
                                                    transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300`}
                      >
                        Descrição da atualização
                      </button>
                    ) : (
                      <button
                        onClick={handleSubmit}
                        disabled={
                          existingFormData && existingFormData.disabledView
                        }
                        className={`linear ml-auto mt-2 w-48 rounded-xl py-[12px] text-base font-medium text-white transition duration-200
                                                    ${
                                                      existingFormData &&
                                                      existingFormData.disabledView
                                                        ? "cursor-not-allowed bg-brand-400"
                                                        : "bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200"
                                                    }`}
                      >
                        Registrar
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/*overlay*/}
            <div className="bg-black fixed inset-0 z-40 opacity-90 backdrop-blur-2xl backdrop-filter"></div>
          </>
        ) : null}
      </>
    );
};

export default TransferModal;
